import { CvaListItemProps } from '../../types';
import { CatListItem } from '@blocks-react/components/ListItem';

export const CVAListItem = ({ children }: CvaListItemProps) => {
  return <CatListItem>{children}</CatListItem>;
};
